import { object, string } from 'yup';
import { useTranslation } from '../../../../../i18n/use-translation';

export function getSignatureValidation() {

    const { t } = useTranslation();
    
    return object().shape({
        _username: string().max(91).required(t('requiredField')),
        _password: string().required(t('requiredField')),
    });
}